import React from "react";
import { Github, Linkedin, Mail, ArrowUp } from "lucide-react";
import { profile } from "../data/mock";

const Footer = () => {
  return (
    <footer className="relative border-t border-teal-500/10 bg-[#03100e]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="flex flex-col lg:flex-row gap-8 items-start lg:items-center justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-gradient-to-br from-teal-400 to-teal-700 flex items-center justify-center text-[#04100f] font-display font-bold">
                {profile.initials}
              </span>
              <div>
                <div className="font-display font-semibold text-slate-100">
                  {profile.name}
                </div>
                <div className="text-xs text-slate-400">
                  {profile.role} · {profile.graduating}
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={`mailto:${profile.email}`}
              className="w-10 h-10 rounded-full border border-teal-500/20 text-slate-300 hover:text-teal-300 hover:border-teal-400 flex items-center justify-center transition-colors"
              aria-label="Email"
            >
              <Mail className="w-4 h-4" />
            </a>
            <a
              href={profile.linkedin}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full border border-teal-500/20 text-slate-300 hover:text-teal-300 hover:border-teal-400 flex items-center justify-center transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-4 h-4" />
            </a>
            <a
              href={profile.github}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full border border-teal-500/20 text-slate-300 hover:text-teal-300 hover:border-teal-400 flex items-center justify-center transition-colors"
              aria-label="GitHub"
            >
              <Github className="w-4 h-4" />
            </a>
            <a
              href="#top"
              className="ml-2 inline-flex items-center gap-1.5 text-sm text-teal-300 hover:text-teal-200 transition-colors"
            >
              Back to top
              <ArrowUp className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-teal-500/10 flex flex-col sm:flex-row gap-2 sm:items-center justify-between text-xs text-slate-500">
          <div>
            © {new Date().getFullYear()} {profile.name}. Designed and built with care.
          </div>
          <div className="font-mono">
            <span className="text-teal-400">$</span> portfolio --status open-to-work
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
